import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import { InteractionType, } from '@debbie/common/dist/interactions/index.js';
import { aggregate } from '@debbie/common/dist/util/index.js';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import Alert from '../../Alert.js';
import CopyToClipboard from '../../CopyToClipboard.js';
import ExclusiveContent from '../../ExclusiveContent.js';
import Modal from '../../Modal.js';
import AutoCallEventCmp from './types/AutoCall.js';
import EBoksEventCmp from './types/EBoks.js';
import EInvoiceEventCmp from './types/EInvoice.js';
import EmailEventCmp from './types/Email.js';
import LetterEventCmp from './types/Letter.js';
import SMSEventCmp from './types/SMS.js';
const Events = (props) => {
    const [events, setEvents] = useState(null);
    const eventsByType = useMemo(() => {
        return Object.values(aggregate((props.interaction.events || []).filter((event) => ![
            InteractionEventType.TransmissionStarted,
            InteractionEventType.Sent,
            InteractionEventType.Created,
            InteractionEventType.Received,
        ].includes(event.type)), (event) => event.type));
    }, [props.interaction.events]);
    const getTooltipEventDetails = (event) => {
        return moment(event.createdAt).format(THEME.DATE_FORMAT_LONG);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(EventTags, null, eventsByType.map((events) => {
            if (!(events && events[0])) {
                return null;
            }
            const event = events[0];
            return (React.createElement(EventTag, { key: event.id, "data-tooltip-html": events
                    .map(getTooltipEventDetails)
                    .join('<br/>'), "data-tooltip-id": "tooltip-default", className: event.type, events: events, onClick: () => {
                    setEvents(events);
                } }));
        })),
        events && (React.createElement(EventsModal, { events: events, closeModal: () => setEvents(null), setEvents: setEvents, interactionType: props.interaction.type }))));
};
export default Events;
const EventsModal = (props) => {
    const { events, setEvents, closeModal } = props;
    const lang = useSelector((s) => s.lang);
    const firstEvent = events[0];
    if (!firstEvent) {
        return null;
    }
    return (React.createElement(Modal, { onToggle: () => {
            setEvents(null);
            closeModal();
        }, header: React.createElement(React.Fragment, null,
            lang.interactionEventTypes[firstEvent.type],
            React.createElement(ExclusiveContent, null,
                ' ',
                React.createElement(CopyToClipboard, { text: JSON.stringify(events) }))), maxWidth: "600px" },
        props.interactionType === InteractionType.SMS &&
            firstEvent.type === InteractionEventType.Delivered &&
            events.length > 1 && (React.createElement(Alert, { message: lang.interactions.smsMultipleDeliveriesWarning })),
        events.map((event) => {
            switch (props.interactionType) {
                case InteractionType.DebtorNote:
                case InteractionType.ClientNote:
                case InteractionType.Email:
                    return React.createElement(EmailEventCmp, { key: event.id, event: event });
                case InteractionType.Eboks:
                    return React.createElement(EBoksEventCmp, { key: event.id, event: event });
                case InteractionType.Letter:
                    return (React.createElement(LetterEventCmp, { key: event.id, event: event }));
                case InteractionType.SMS:
                    return React.createElement(SMSEventCmp, { key: event.id, event: event });
                case InteractionType.AutoCall:
                    return (React.createElement(AutoCallEventCmp, { key: event.id, event: event }));
                case InteractionType.EInvoice:
                    return (React.createElement(EInvoiceEventCmp, { key: event.id, event: event }));
                default:
                    return null;
            }
        })));
};
const EventTagStyled = styled.span `
  background: ${THEME.COLOR_GREY};
  display: inline-flex;
  align-items: center;
  border-radius: 3px;
  color: ${THEME.COLOR_SECONDARY};
  padding: 0.2em 0.6em;
  font-size: 0.7em;
  font-weight: bold;
  margin-right: 5px;
  cursor: pointer;
  user-select: none;

  &.delivered {
    background: ${THEME.SUCCESS};
  }

  &.failed {
    background: ${THEME.DANGEROUS};
  }

  &.complained {
    background: ${THEME.WARNING};
  }

  & > span {
    background-color: ${THEME.COLOR_SECONDARY};
    color: ${THEME.COLOR_PRIMARY};
    font-size: 0.7em;
    border-radius: 2px;
    margin-left: 5px;
    padding: 1px 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    margin-right: -3px;
  }
`;
export const EventTag = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(EventTagStyled, { ...props },
        lang.interactionEventTypes[props.events[0].type],
        props.events.length > 1 ? React.createElement("span", null, props.events.length) : ''));
};
export const EventTags = styled.span ``;
//# sourceMappingURL=Events.js.map